import m from "./_copyObject.js";
import r from "./_getSymbolsIn.js";
function e(o, t) {
  return m(o, r(o), t);
}
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_copySymbolsIn.js
// module id = 1502
// module chunks = 67